import imageCompression from 'browser-image-compression';

export const compressFile = async (file: File): Promise<Blob | null> => {
    try {
        if (!file) return null;
        const options = {
            maxSizeMB: 0.06,
            maxWidthOrHeight: 1024,
            useWebWorker: true,
        };
        const fileSize = parseFloat((file.size / 1024 / 1024).toFixed(2));
        console.log(`Selected file size = ${fileSize} mb`);
        if (fileSize < options.maxSizeMB) return file;
        const compressedFile = await imageCompression(file, options);
        console.log(`Compressed file size = ${(compressedFile.size / 1024 / 1024).toFixed(3)} mb`);
        return compressedFile;
    } catch (error) {
        console.log(error);
        return null;
    }
};

export const upload = async (file: File, compress = true): Promise<string | null> => {
    if (!file) return '';

    const resolvedFile = compress === true ? await compressFile(file) : file;
    if (resolvedFile == null) return '';

    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(resolvedFile);
        reader.onerror = (error) => reject(error);
        reader.onload = () => resolve(reader.result as string);
    });
};
